/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from 'react';
import {
  FormControl,
  InputLabel,
  OutlinedInput,
  Chip,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Box,
  TextField,
} from '@mui/material';
import { useLocation, useNavigate } from 'react-router-dom';
import { t } from 'i18next';
import { isArray } from 'lodash';

const AdvancedSearch = ({ filter }) => {
  const location = useLocation();
  const navigate = useNavigate();

  const filterTypes = isArray(filter) ? filter : [];

  // إعداد القيم الافتراضية بناءً على نوع الداتا
  const initialFilterInputs = filterTypes.map((type) =>
    type.dataType === 'date'
      ? { type: type.filter, value: { from: '', to: '' }, dataType: 'date' }
      : { type: type.filter, value: '', dataType: type.dataType || 'text' }
  );

  const [isDialogOpen, setDialogOpen] = useState(false);
  const [filterInputs, setFilterInputs] = useState(initialFilterInputs);

  // تحديث القيم من الرابط
  useEffect(() => {
    fetchDataFromUrl();
    // eslint-disable-next-line
  }, [location.search]);

  // تحديث الرابط عند تغيير الفلاتر
  useEffect(() => {
    updateURLQuery();
    // eslint-disable-next-line
  }, [filterInputs]);

  // تحديث الرابط
  const updateURLQuery = () => {
    const searchParams = new URLSearchParams(location.search);

    const filterQueryString = filterInputs
      .filter(({ value, dataType }) =>
        dataType === 'date'
          ? value.from && value.to
          : value && value !== ''
      )
      .map(({ type, value, dataType }) =>
        dataType === 'date'
          ? `${type}:${value.from}|${value.to}`
          : `${type}:${value}`
      )
      .join(',');

    if (filterQueryString) {
      searchParams.set('AdvancedSearch', filterQueryString);
    } else {
      searchParams.delete('AdvancedSearch');
    }

    navigate({ search: searchParams.toString() });
  };

  // جلب القيم من الرابط
  const fetchDataFromUrl = () => {
    const searchParams = new URLSearchParams(location.search);
    const filterQueryString = searchParams.get('AdvancedSearch');

    if (filterQueryString) {
      const filters = filterQueryString.split(',').map((filter) => {
        const [type, value] = filter.split(':');
        const filterType = filterTypes.find((f) => f.filter === type);
        if (filterType && filterType.dataType === 'date') {
          const [from, to] = value.split('|');
          return { type, value: { from, to }, dataType: 'date' };
        }
        return { type, value, dataType: filterType?.dataType || 'text' };
      });

      // تأكد من وجود جميع الفلاتر
      const updatedFilterInputs = filterTypes.map((type) => {
        const existingFilter = filters.find((filter) => filter.type === type.filter);
        if (type.dataType === 'date') {
          return (
            existingFilter || { type: type.filter, value: { from: '', to: '' }, dataType: 'date' }
          );
        }
        return existingFilter || { type: type.filter, value: '', dataType: type.dataType || 'text' };
      });

      setFilterInputs(updatedFilterInputs);
    } else {
      setFilterInputs(initialFilterInputs);
    }
  };

  // إغلاق الديالوج بدون حفظ
  const handleCloseDialog = () => {
    setDialogOpen(false);
    fetchDataFromUrl();
  };

  // حفظ الفلاتر
  const handleSaveDialog = () => {
    setDialogOpen(false);
    updateURLQuery();
  };

  // إزالة فلتر
  const handleRemoveFilter = (typeToRemove) => {
    const updatedFilterInputs = filterInputs.map((filter) => {
      if (filter.type === typeToRemove) {
        if (filter.dataType === 'date') {
          return { ...filter, value: { from: '', to: '' } };
        }
        return { ...filter, value: '' };
      }
      return filter;
    });
    setFilterInputs(updatedFilterInputs);
  };

  // تغيير قيمة فلتر نصي
  const handleFilterInputChange = (index) => (event) => {
    setFilterInputs((prev) => {
      const updated = [...prev];
      updated[index].value = event.target.value;
      return updated;
    });
  };

  // تغيير قيمة فلتر تاريخ
  const handleDateInputChange = (index, field) => (event) => {
    setFilterInputs((prev) => {
      const updated = [...prev];
      updated[index].value = {
        ...updated[index].value,
        [field]: event.target.value,
      };
      return updated;
    });
  };

  return (
    <Box>
    
      <Button sx={{ minWidth: '170px' }} color="primary" onClick={() => setDialogOpen(true)}>
        {t('Advanced Search')}
      </Button>
      <Box
        sx={{
          display: 'flex',
          width: '100%',
          flexDirection: 'row',
          flexWrap: 'wrap',
          gap: 2,
          justifyContent: 'start',
          alignContent: 'start',
        }}
      >
        {filterInputs.map((filter, index) => (
          <React.Fragment key={index}>
            {filter.dataType === 'date' && filter.value.from && filter.value.to && (
              <Chip
                label={`${filter.type}: ${filter.value.from} ~ ${filter.value.to}`}
                onDelete={() => handleRemoveFilter(filter.type)}
                onClick={() => setDialogOpen(true)}
              />
            )}
            {filter.dataType !== 'date' && filter.value && (
              <Chip
                label={`${filter.type}: ${filter.value}`}
                onDelete={() => handleRemoveFilter(filter.type)}
                onClick={() => setDialogOpen(true)}
              />
            )}
          </React.Fragment>
        ))}
      </Box>
      <Dialog open={isDialogOpen} onClose={handleCloseDialog} PaperProps={{
  sx: { borderRadius: 3, minWidth: 400, maxWidth: 650 }
}}>
  
        <DialogTitle sx={{ fontWeight: 700, fontSize: 22, pb: 1  }}>
          {t('Advanced Search')}
        </DialogTitle>
        <DialogContent sx={{ width: '100%', bgcolor: "#f7f8fa", borderRadius: 2, p: 3 }}>
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'row',
              flexWrap: 'wrap',
              gap: 3,
              justifyContent: 'flex-start',
              alignItems: 'flex-start',
            }}
          >
            {filterInputs.map((filter, index) => (
              <Box
                key={index}
                sx={{
                  width: { xs: '100%', sm: '45%' },
                  bgcolor: "#fff",
                  borderRadius: 2,
                  boxShadow: "0 1px 6px 0 rgba(11,60,93,0.08)",
                  p: 2,
                  mb: 2,
                  minWidth: 180,
                }}
              >
                <InputLabel sx={{ mb: 1, fontWeight: 600, color: "primary.main" }}>{t(filter.type)}</InputLabel>
                {filter.dataType === 'date' ? (
                  <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                    <TextField
                      type="date"
                      label={t('From')}
                      InputLabelProps={{ shrink: true }}
                      value={filter.value.from}
                      onChange={handleDateInputChange(index, 'from')}
                      size="small"
                      sx={{ mb: 1 }}
                    />
                    <TextField
                      type="date"
                      label={t('To')}
                      InputLabelProps={{ shrink: true }}
                      value={filter.value.to}
                      onChange={handleDateInputChange(index, 'to')}
                      size="small"
                    />
                  </Box>
                ) : (
                  <TextField
                    label={t('Value')}
                    value={filter.value || ''}
                    onChange={handleFilterInputChange(index)}
                    size="small"
                    fullWidth
                  />
                )}
              </Box>
            ))}
          </Box>
        </DialogContent>
        <DialogActions sx={{ px: 3, pb: 2 }}>
          <Button onClick={handleCloseDialog} color="inherit" variant="outlined" sx={{ borderRadius: 2 }}>
            {t('Cancel')}
          </Button>
          <Button onClick={handleSaveDialog} color="primary" variant="contained" sx={{ borderRadius: 2 }}>
            {t('Done')}
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default AdvancedSearch;
